<template>
	<div>
		<div class="container-ocuppancy pa-1 mb-3">
			<v-flex xs4 pl-0 mb-0> 
					<v-layout row wrap class="calendar-range">
        		<v-flex md6 pa-0 class="border-right">
          		<v-menu
          		lazy
          		v-model="menuStart"
          		transition="scale-transition"
          		offset-y
          		full-width
          		:nudge-left="40"
          		class="menu-date-picker"
          		max-width="290px">
          		<v-text-field
            		slot="activator"
					v-model="dateStart"
            		label="Picker in menu"
            		prepend-icon="event"
					:disabled="!dateStart"
            		:append-icon="arrowIconStart"
            		single-line
            		hide-details
            		readonly
							></v-text-field>
							<v-date-picker
							v-model="dateStart"
								no-title
								scrollable
								@input="getOccupation">
							</v-date-picker>
						</v-menu>
     			 </v-flex>
      		<v-flex md6 pa-0 md-2>
        		<v-menu
          		lazy
							v-model="menuEnd"
							transition="scale-transition"
							offset-y
							full-width
							class="menu-date-picker"
							max-width="290px">
          	<v-text-field
							slot="activator"
							label="Picker in menu"
							:append-icon="arrowIconEnd"
							v-model="dateEnd"
							single-line
							hide-details
							readonly
          	></v-text-field>
         	 	<v-date-picker
            	no-title
				v-model="dateEnd"
            	scrollable
            	@input="deactived">
          	</v-date-picker>
        	</v-menu>
      	</v-flex>
    	</v-layout>
		</V-flex>
	<v-layout 
			align-center
			justify-end
			row wrap
			class="header-booking-data">
			<v-flex xs3>
				<v-select
					class="filter-select"
					v-bind:items="subsidiaries"
					label="qp Hotels Lima"
					item-text="name"
					item-value="id"
					v-model="idSubsidiary"
					hide-details
					single-line
					@input="getOccupation"
					bottom>
				</v-select>
			</v-flex>
		</v-layout>
		<v-layout row wrap justify-space-between>
			<v-flex  xs4>
			<section class="filters-by-time row wrap">
				<v-btn v-for="filter in filters"
					:key="filter.id"
					:class="{'activeBtn': filter.id === value}"
					@click="onDateFilter(filter)"
					:disabled="loading">
					{{filter.label}}
				</v-btn>
				<v-btn class="btn-usage row wrap" :to="{name: 'report-occupancy'}">
					<img src="/static/img/pie-chart-outline.svg" alt="" height="25px" width="25px">
				</v-btn>
			</section>
		</v-flex>
			<v-flex xs4 pl-6 md-0>
				<v-btn
					type="button"
					class="btn-action btn-success white--text"
					@click="customButtons">
				<v-icon>print</v-icon>
					Imprimir Reporte
				</v-btn>	
			</v-flex>
		</v-layout>
		</div>
		<v-layout row wrap mt-3>
			<v-flex xs12>
				<v-tabs class="checkin-tabs">
					<v-tabs-items>
						<table>
							<tr>
								<th v-for="(item, indexOcu) in occupation" :key="indexOcu">{{item.name}}<br>
									<span :class="{'colorGreen': (0 < item.percent && item.percent <= 49) ,'colorYellow': (50 <= item.percent && item.percent <= 79), 'colorRed': (80 <= item.percent && item.percent <= 100) }">{{item.percent}} <span v-if="item.percent">%</span> </span>
								</th>
							</tr>
							<tr v-for="(occupationTable, indexBody) in occupationBody" :key="indexBody" @actions="customButtons">
								<td>{{occupationTable.date}}</td>
								<td v-for="(typeRoom, indexRoomType) in occupationTable.roomTypes" :key="indexRoomType">{{typeRoom.value}}</td>
								<td>{{occupationTable.occupied}}</td>
								<td>{{occupationTable.free}}</td>
								<td :class="{'colorGreen': (0 < occupationTable.percent && occupationTable.percent <= 49) ,'colorYellow': (50 <= occupationTable.percent && occupationTable.percent <= 79), 'colorRed': (80 <= occupationTable.percent && occupationTable.percent <= 100) }">{{occupationTable.percent}}</td>
							</tr>
						</table>
					</v-tabs-items>
				</v-tabs>
			</v-flex>
		</v-layout>	
	</div>
</template>

<script>
	import TableRun from 'table-run';
	import { addDays, format, subDays } from 'date-fns';
	import FiltersByTime from '@/components/shared/FiltersByTime';
	import helper from '@/shared/helper';
	import mixin from '@/shared/mixins';


	const helperMethods = helper.methods;

	function created() {
		this.loadResources();
	}

	function columnSortableEvent() {}

	async function loadResources() {
		const { data: subsidiaries } = await this.$http.get(`${process.env.PMS_URL}/hotel`);
		this.subsidiaries = subsidiaries.data;
		this.idSubsidiary = this.subsidiaries[0].id;
		this.getOccupation();
	}

	function deactived() {
		this.value = 0;
		this.getOccupation();
	}

	async function getOccupation() {
		const params = {
			dateStart: this.dateStart,
			dateEnd: this.dateEnd,
			idSubsidiary: this.idSubsidiary,
		};
		const dateOccupations = await this.$http.get(`${process.env.PMS_URL}/occupation-rank`, { params });
		this.occupation = dateOccupations.body.headers;
		this.occupationBody = dateOccupations.body.data;
	}

	function arrowIconStart() {
		const arrow = this.menuStart ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrow;
	}

	function arrowIconEnd() {
		const arrowEnd = this.menuEnd ? 'arrow_drop_up' : 'arrow_drop_down';
		return arrowEnd;
	}


	function onDateFilter(filter) {
		this.value = filter.id;
		if (this.value === 3) {
			this.dateEnd = format(addDays(new Date(), 31), 'YYYY-MM-DD');
		} else if (this.value === 2) {
			this.dateEnd = format(addDays(new Date(), 7), 'YYYY-MM-DD');
		} else {
			this.dateEnd = format(addDays(new Date(), 0), 'YYYY-MM-DD');
		}
		this.getOccupation();
	}

	function data() {
		return {
			imageOccupation: '/static/img/pie-chart-outline.svg',
			occuArray: [],
			occupationBody: [],
			idSubsidiary: '',
			occupation: [],
			dateEnd: format(new Date(), 'YYYY-MM-DD'),
			dateStart: format(subDays(new Date(), 0), 'YYYY-MM-DD'),
			menuStart: false,
			menuEnd: false,
			active: '',
			date: format(new Date(), 'YYYY-MM-DD'),
			filters: [
				{
					id: 1, value: 1, label: 'Día',
				},
				{
					id: 2, value: 2, label: 'Semana',
				},
				{
					id: 3, value: 3, label: 'Mes',
				},
			],
			loading: false,
			noShowData: [],
			optionButtonsCheckin: [
				{
					id: 1,
					icon: 'print',
					name: 'registration-card',
				},
			],
			printInHouse: {
				btn: { name: 'registration-card' },
			},
			rowSelected: {},
			subsidiaries: [],
			subsidiary: {},
			totalData: [],
			value: 1,
			voidData: [],
			url: 'occupancy',
		};
	}

	function customButtons() {
		this.printReports();
	}

	async function printReports() {
		const baseUrl = `${process.env.PMS_URL}/report/occupancy/`;
		const dateStart = this.dateStart;
		const dateEnd = this.dateEnd;
		const idSubsidiary = this.idSubsidiary;
		const name = 'Reporte Ocupaciòn';
		const responseType = 'blob';
		const cardModel = { occupation: [{}] };
		const response = await this.$http.post(`${baseUrl}?dateStart=${dateStart}&dateEnd=${dateEnd}&idSubsidiary=${idSubsidiary}`, cardModel, { responseType },
		);
		const blob = helperMethods.generateBlob(response.bodyBlob);
		helperMethods.showDownloadDialog(blob, name, 'pdf');
	}

	export default {
		name: 'report-bookings',
		mixins: mixin,
		components: {
			FiltersByTime,
			TableRun,
		},
		computed: {
			arrowIconStart,
			arrowIconEnd,
		},
		created,
		data,
		methods: {
			customButtons,
			printReports,
			deactived,
			getOccupation,
			columnSortableEvent,
			loadResources,
			onDateFilter,
		},
	};
</script>

<style lang="scss" scoped>
.checkin-tabs {
	.colorGreen {
		color: green;
	}
}

.checkin-tabs {
	.colorRed {
		color: red;
	}
}

.checkin-tabs {
	.colorYellow {
		color: yellow;
	}
}

	.container-button {
		left: 280px;
		position: relative;
	}
	
	table, td, th {
		border: 1px solid #979797;
	}

	tr:nth-child(even) {
		background-color: #f2f2f2;
	}

	tr:hover {
		background-color: #ddd;
	}

	td {
		color: #2f302f;
		padding: 10px;
	}

	table {
		border-collapse: collapse;
		width: 100%;
	}

	th {
		background: #545e72;
		color: #ffffff;
		padding: 10px;
		text-align: center;
	}

	.container-ocuppancy {
		align-items: center;
		display: flex;
		justify-content: space-between;
		width: 100%;
	}

	.header-booking-data {
		height: 31px;
		position: absolute;
		right: 20px;
		text-align: right;
		top: 52px;
		width: calc(100% - 230px);

		p {
			color: map-get($colors, blue-title);
			font-family: map-get($fonts, regular);
			font-size: 10px;
			margin: 0px;
			text-transform: uppercase;
		}

		span {
			color: map-get($colors, default-skyblue);
			font-family: map-get($fonts, medium);
			font-size: 15px;
		}
	}

	.td-state {
		span.booking-td {
			color: map-get($colors, booking-td);
		}

		span.inhouse-td {
			color: map-get($colors, inhouse);
		}
	}

	.btn-usage {
		background-color: white !important;
		height: 39px;
		margin: 0 10px;
		width: 55px;
	}

	.border-right {
		border-right: 1px solid map-get($colors, e-bg-icon);
	}	
</style>


// WEBPACK FOOTER //
// Occupancy-new.vue?0748dce0